import moment from 'moment';
const emptyBody = {
  plan_date: '',
  plan_desc: '',
  plan_num: '',
  num: '',
  plan_yyyymm: '',
  update_order: '',
};
const returnMonthAry = ({ start, end, data }) => {
  const old_ary = data.sub3 || [];
  if (start > end) return [];
  const ary = [];
  let start_Y = parseInt(start.format('Y'));
  let start_M = parseInt(start.format('M'));
  const end_Y = parseInt(end.format('Y'));
  const end_M = parseInt(end.format('M'));

  while (end_Y >= start_Y) {
    if (end_Y === start_Y) {
      while (end_M >= start_M) {
        ary.push(`${start_Y}.${start_M}`);
        start_M += 1;
      }
    } else {
      while (start_M <= 12) {
        ary.push(`${start_Y}.${start_M}`);
        if (start_M < 12)start_M += 1;
        else { start_M = 1; break; }
      }
    }
    start_Y += 1;
  }
  return ary.map(o => {
    let body = { ...emptyBody };
    for (let i = 0; i < old_ary.length; i++) {
      if (old_ary[i].plan_yyyymm === o) {
        body = { ...body, ...old_ary[i] };
        break;
      }
    }
    return { ...body, plan_yyyymm: o };
  });
};
const returnWeekAry = ({ start, end, data }) => {
  const old_ary = data.sub5 || [];
  if (start > end) return [];
  const ary = [];
  let start_Y = start.weekYear();
  let start_W = start.week();
  const end_Y = end.weekYear();
  const end_W = end.week();

  while (end_Y >= start_Y) {
    if (end_Y === start_Y) {
      while (end_W >= start_W) {
        ary.push(`${start_Y}.W${start_W}`);
        start_W += 1;
      }
    } else {
      let max_Day = moment(new Date(start_Y, 11, 31));
      max_Day = max_Day.subtract(max_Day.day() === 6 ? 0 : max_Day.day() + 1, 'days');
      const max_W = max_Day.week();
      while (start_W <= max_W) {
        ary.push(`${start_Y}.W${start_W}`);
        if (start_W < max_W)start_W += 1;
        else { start_W = 1; break; }
      }
    }
    start_Y += 1;
  }
  return ary.map(o => {
    let body = { ...emptyBody };
    for (let i = 0; i < old_ary.length; i++) {
      if (old_ary[i].plan_yyyymm === o) {
        body = { ...body, ...old_ary[i] };
        break;
      }
    }
    return { ...body, plan_yyyymm: o };
  });
};

const returnDatePeriod = t => {
  if (!t) return '';
  const year = t.substring(0, t.indexOf('.'));
  const week = t.substring(t.indexOf('W') + 1);

  return `(W${week})${moment(`${year}`, 'GGGG').week(week).weekday(0).format('YYYY.MM.DD')} ~ ${moment(`${year}`, 'GGGG').week(week).weekday(6).format('YYYY.MM.DD')}`;
};

export { returnMonthAry, returnWeekAry, returnDatePeriod };
